import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$el.addEventListener("click", this.onClickBind);
    }

    unbindEvents() {
        this.$el.removeEventListener("click", this.onClickBind);
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick() {
        this.call('toggle', null, 'Cart', 'cartModal')
        this.call('close', null, 'SearchBar')
        this.call('close', null, 'Menu')
        this.call('lazyloadImages', null, 'Carousel', 'cart', 'cartModal')
    }
}
